import { useAtsConversationApi } from '@/composables/useApi';
import type { InterviewSchedulingEvent } from './types/interview-scheduling-event.type';

export class InterviewSchedulingPersistence {
  async getEventsByConversationId(
    employerId: number,
    conversationId: number,
  ): Promise<InterviewSchedulingEvent[]> {
    const url = `/interview-scheduling/employer/${employerId}/conversation/${conversationId}/events`;
    const { data, error } = await useAtsConversationApi(url)
      .get()
      .json<InterviewSchedulingEvent[]>();

    if (error.value) {
      throw new Error(error.value);
    }

    return data.value || [];
  }

  async getRecentLocations(employerId: number): Promise<string[]> {
    const url = `/interview-scheduling/employer/${employerId}/recent-interview-locations`;
    const { data, error, statusCode } = await useAtsConversationApi(url)
      .get()
      .json<{ locations: string[] }>();

    if (statusCode.value === 403) {
      return [];
    }

    if (error.value) {
      throw new Error(`HTTP ${statusCode.value}: ${error.value}`);
    }

    return data.value?.locations ?? [];
  }
}
